import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { KpiCard } from '@/components/kpi-card';
import { ComingSoon } from '@/components/coming-soon';
import { getModuleStats } from '@/lib/modules-api';
import { fmtNumber } from '@/lib/format';

export const Route = createFileRoute('/_app/masters')({ component: Page });

function Page() {
  const q = useQuery({ queryKey: ['modules:stats'], queryFn: getModuleStats, staleTime: 5 * 60_000 });
  return (
    <ComingSoon
      module="Masters"
      description="Brands, colors, sizes, categories, stores — all reference data the system depends on."
      comingIn="v3"
      features={[
        'Brand / color / size / category CRUD',
        'Store master with address + GST',
        'Bulk import / export',
        'Audit trail (who changed what, when)',
      ]}
    >
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <KpiCard label="Brands"      value={q.data ? fmtNumber(q.data.masters.brands) : '—'} />
        <KpiCard label="Colors"      value={q.data ? fmtNumber(q.data.masters.colors) : '—'} />
        <KpiCard label="Sizes"       value={q.data ? fmtNumber(q.data.masters.sizes) : '—'} />
        <KpiCard label="Categories"  value={q.data ? fmtNumber(q.data.masters.categories) : '—'} />
      </div>
    </ComingSoon>
  );
}
